module.exports = __webpack_public_path__ + "static/media/arrows-h.9aa4d9fb.svg";